import { h } from 'preact';
import classNames from 'classnames';
import ChatIcon from 'widget_main/components/ChatIcon';
import { useTranslations } from 'i18n/hooks';
import styles from './avatar.scss';

import messages from './messages';

interface AvatarProps {
  size?: number;
  className?: string;
  orgIconClassName?: string;
  avatarUrl?: string;
}

const Avatar = ({
  size,
  className,
  orgIconClassName,
  avatarUrl,
}: AvatarProps) => {
  const translations = useTranslations(messages);

  const renderAvatarUrl = () => {
    if (!avatarUrl || avatarUrl.slice(-5) === 'blank') {
      return <ChatIcon size={size} className={orgIconClassName} />;
    }

    return (
      <div
        role="img"
        aria-label={translations.agentAvatar}
        class={styles.customImg}
        style={{ backgroundImage: `url(${avatarUrl})` }}
      />
    );
  };

  return (
    <div
      style={{ width: `${size}px`, height: `${size}px` }}
      class={classNames(styles.avatar, className)}
    >
      {renderAvatarUrl()}
    </div>
  );
};

Avatar.defaultProps = {
  size: 40,
};
export default Avatar;
